/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { keyframes, styled } from '@mui/material/styles'

export const backgroundLightBoxOpen = keyframes`
  0% {
    opacity: 0.8;
  }

  100% {
    opacity: 1;
  }
`

export const backgroundLightBoxClose = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`


export const anchorBottomEnter = keyframes`
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`

export const anchorBottomExit = keyframes`
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
`

export const anchorLeftEnter = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100vw, 0, 0);
    transform: translate3d(-100vw, 0, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`

export const anchorRightEnter = keyframes`
  0% {
    -webkit-transform: translate3d(100vw, 0, 0);
    transform: translate3d(100vw, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`

export const anchorLeftExit = keyframes`
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(-100vw, 0, 0);
    transform: translate3d(-100vw, 0, 0);
  }
`

export const anchorRightExit = keyframes`
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(100vw, 0, 0);
    transform: translate3d(100vw, 0, 0);
  }
`

export const mobileBrowserMenuEnterRecord: any = {
  0: anchorBottomEnter,
  1: anchorRightEnter,
  2: anchorRightEnter,
}

export const mobileBrowserMenuExitRecord: any = {
  0: anchorBottomExit,
  1: anchorRightExit,
  2: anchorRightExit,
}

const getAnimationAnchorType = (isGlobalOpen: boolean, isOpen: boolean, level: number) => {
  if ( !isGlobalOpen ) {
    return anchorBottomExit
  }
  
  return isOpen ? mobileBrowserMenuEnterRecord[level] : mobileBrowserMenuExitRecord[level]
}

export const StyledListContainer = styled('ul')`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const StyledMobileCategoryBrowserNavigation = styled('div')<{ $isGlobalOpen: boolean; $isOpen: boolean; $level: number; $animationTime: number }>`
  display: block;
  position: fixed;
  top: ${props => (props.$level == 0) ? props.theme.typography.pxToRem(74) : props.theme.typography.pxToRem(128)};
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(100vh - ${props => (props.$level == 0) ? props.theme.typography.pxToRem(74) : props.theme.typography.pxToRem(128)}));
  background: ${props => props.theme.palette.background.default};
  overflow-y: scroll !important;
  transform: translate3d(0, 0, 0);
  border-radius: ${props => props.$level == 0 ? props.theme.typography.pxToRem(16) : 0} ${props => props.$level == 0 ? props.theme.typography.pxToRem(16) : 0} 0 0;
  z-index: ${props => props.$level === 0 ? props.theme.zIndex.appBar + 1 : (props.theme.zIndex.appBar + 1) * props.$level  * 1000};
  animation: ${props => getAnimationAnchorType(props.$isGlobalOpen, props.$isOpen, props.$level)} ${props => props.$animationTime}ms ${props => props.$level == 0 ? 'cubic-bezier(0.18, 0.78, 0.43, 1.1)' : 'ease-in-out'};
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`
export const StyledModalBackground = styled('div')<{ $isGlobalOpen: boolean }>`
  position: fixed;
  z-index: ${props => props.theme.zIndex.appBar};
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  animation: ${props => props.$isGlobalOpen ? backgroundLightBoxOpen : backgroundLightBoxClose} 270ms ease-in-out;
`